// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { PermissionService } from './permissionService';

export const USER_PERMISSION_KEY: InjectionKey<PermissionService> = Symbol('PermissionService');

export function useUserPermissions(): PermissionService {
	const service = inject<PermissionService>(USER_PERMISSION_KEY);
	if (!service) throw new Error('PermissionService not provided');
	return service;
}
